import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { SITE_ENDPOINT } from './../Constant';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const defaultBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Page 1',
    url: '#!'
  },
  {
    label: 'Page 2',
    url: '#!'
  },
  {
    label: 'Default',
    active: true
  }
];

export const homepageBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    active: true
  }
];

export const jobBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Job Dashboard',
    url: '/home'
  },
  {
    label: 'Create Job',
    active: true
  }
];

export const ecomBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Fashion',
    url: '#!'
  },
  {
    label: 'Womens Fashion',
    url: '#!'
  },
  {
    label: 'Footwear',
    url: '#!'
  },
  {
    label: 'Hills',
    active: true
  }
];

export const EmployeeBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Employee',
    url: '/home/apps/employee'
  },
  {
    label: 'Create Employee',
    active: true
  }
];

export const EmployeeViewBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Employee',
    url: '/home/apps/employee',
    active: true
  }
];

export const CustomerBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Company',
    url: '/home/apps/' + SITE_ENDPOINT.COMPANY.INDEX
  },
  {
    label: 'Create Customer',
    active: true
  }
];

export const CustomerEditBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Company',
    url: '/home/apps/' + SITE_ENDPOINT.COMPANY.INDEX
  },
  {
    label: 'Edit Company',
    active: true
  }
];

export const CustomerViewBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View Company',
    url: '/home/apps/' + SITE_ENDPOINT.COMPANY.INDEX,
    active: true
  }
];

export const RepBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Representative',
    url: '/home/apps/representative/'
  },
  {
    label: 'Create Representative',
    active: true
  }
];

export const RepViewBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Representative',
    url: '/home/apps/representative',
    active: true
  }
];

export const RoleBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Role',
    active: true
  }
];

export const TaskBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/home'
  },
  {
    label: 'View All Task',
    active: true
  }
];

export const TaskViewBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Tasks',
    url: '/home/apps/tasks'
  },
  {
    label: 'View Task',
    active: true
  }
];
